import { FC } from 'react';
import Image from 'next/image';
import styled from 'styled-components';

import { FileInfo } from '@/widgets/modals/containers/FilePreviewModal/FilePreview';
import { useModalsStore } from '@/widgets/modals/modals.store';

type DocumentProps = {
  image: string;
  title: string;
  file?: FileInfo;
};

export const Document: FC<DocumentProps> = ({ file, image, title }) => {
  const modals = useModalsStore();

  const handleClick = () => {
    if (!file) return;
    modals.openModal({
      type: 'FilePreviewModal',
      mode: 'fileInfo',
      fileInfo: file,
    });
  };

  return (
    <Container onClick={handleClick}>
      <Image src={image} width={80} height={105} alt={title} />
      <Text>{title}</Text>
    </Container>
  );
};

const Container = styled.button`
  cursor: pointer;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  background: none;
  border: none;
  color: inherit;
  font-size: inherit;
  font-family: inherit;

  @container (width < 922px) {
    flex-direction: row;
    align-items: start;
    text-align: left;
  }
`;

const Text = styled.p`
  font-weight: 700;
  line-height: 20px;

  @container (width < 922px) {
    margin-top: 16px;
  }
`;
